import React, { useMemo } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { useMediaQuery } from "react-responsive"

import IconInfoBlock from "components/IconInfoBlock"
import ClockIcon from "assets/svgs/icons/clock_icon.svg"
import PointIcon from "assets/svgs/icons/point_icon.svg"
import CogwheelIcon from "assets/svgs/icons/cogwheel_icon.svg"
import BellIcon from "assets/svgs/icons/bell_icon.svg"
import DocumentIcon from "assets/svgs/icons/document_icon.svg"

import * as Styled from "./styles"

import { LandingPagesProps } from "types/interfaces"
import { LandingPageType } from "types/enums"

interface InfoBlock {
  node: {
    id: string
    frontmatter: {
      order: number
      title1: string
      title2: string
      content: string
    }
  }
}

interface InfoBlockObject {
  title1: string
  title2: string
  content: string
}

export const blockQuery = graphql`
  query InfoBlocksData {
    allMarkdownRemark(
      sort: { fields: frontmatter___order }
      filter: { frontmatter: { category: { eq: "info block" } } }
    ) {
      edges {
        node {
          id
          frontmatter {
            order
            content
            title1
            title2
          }
        }
      }
    }
  }
`

const vendorTexts: InfoBlockObject[] = [
  {
    title1: "All in",
    title2: "one place",
    content:
      "One platform that enables smooth information flow across all involved parties and speeds up the process.",
  },
  {
    title1: "Fast & Efficient",
    title2: "COI process",
    content:
      "Standard processes need up to 24h/48h to make a COI, including a few hours of interactions with participants. Our solution turns hours into minutes.",
  },
  {
    title1: "Always",
    title2: "up to date",
    content: "Get real-time updates about COIs thanks to Movezee.",
  },
]

const InfoBlocksSection: React.FC<LandingPagesProps> = ({ landingType }) => {
  const { allMarkdownRemark } = useStaticQuery(blockQuery)
  const infoBlocks: InfoBlock[] = allMarkdownRemark.edges
  const iconsComponents = useMemo(
    () =>
      landingType === LandingPageType.MANAGEMENT_COMPANIES
        ? [<PointIcon />, <ClockIcon />, <CogwheelIcon />]
        : [<PointIcon />, <DocumentIcon />, <BellIcon />],
    [landingType]
  )

  const isTabletSize = useMediaQuery({
    query: "(max-width: 1023px)",
  })

  return (
    <Styled.Wrapper alignCenter={isTabletSize}>
      {landingType === LandingPageType.MANAGEMENT_COMPANIES
        ? infoBlocks.map(({ node }, index) => (
            <IconInfoBlock
              key={node.id}
              {...node.frontmatter}
              icon={iconsComponents[index]}
            />
          ))
        : vendorTexts.map((item, index) => (
            <IconInfoBlock
              key={index}
              icon={iconsComponents[index]}
              title1={item.title1}
              title2={item.title2}
              content={item.content}
            />
          ))}
    </Styled.Wrapper>
  )
}

export default InfoBlocksSection
